import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import MainContactBlockData from './Data';
import MainContactBlockView from './View';

const MainContactBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <MainContactBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <MainContactBlockData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(MainContactBlockEdit);
